import axios from 'axios';

const service = axios.create({
   baseURL: '/api/ajax/UserBehavior/'
});

export default {
   /**
    * Gets user behaviors by types
    * @returns {Promise<UserBehavior[]|boolean>} Array of user behaviors, or `false` if fetching failed.
    */
   async GetUserBehaviorsByTypes(params) {
      return await axios.post('/api/ajax/UserBehavior/GetUserBehaviorsByTypes', params);
   },

   /**
    * Create or update user behavior
		* @returns {Boolean}
    */
   async CreateOrUpdateUserBehaviors(params) {
      return await axios.post('/api/ajax/UserBehavior/CreateOrUpdateUserBehaviors', params);
   },

   /**
    * Removes user behavior
		* @returns {Boolean}
    */
   async DeleteUserBehaviorsByTypes(params) {
      return await axios.delete('/api/ajax/UserBehavior/DeleteUserBehaviorsByTypes', params);
   },

   async GetPurchaseHistory(params) {
      return await axios.post('/api/ajax/UserBehavior/GetPurchaseHistory', params);
   }
};
